module.exports = __webpack_public_path__ + "img/7.9.TU.bf618d5a.png";